import { IActivity } from '../../../App/store/features/activity/interface/IActivityList'
import { TErrorDescriptor } from '../../../Common/ErrorHandling/store'
import { AppDispatch } from '../../../store'
import { createAppointment } from '../../store/thunks/createAppointment'
import { ICopyForm } from '../../types'
import { IEmptySlotClick } from '../../types/IEmptySlotClick'
import { transformPasteToCreateAppointment } from '../transformOpenFormToSubmit'

const hasUuid = (
  object: Partial<TErrorDescriptor & { uuid: string }>,
): object is TErrorDescriptor & { uuid: string } => {
  return !!object.uuid
}

export const copyUpdate = (
  openFormDetails: ICopyForm,
  lastEmptySlotClick: IEmptySlotClick,
  activityList: IActivity[],
  dispatch: AppDispatch,
) => {
  const createObject = transformPasteToCreateAppointment(
    openFormDetails.event,
    lastEmptySlotClick.clickedMoment,
    lastEmptySlotClick.person,
    activityList,
  )
  dispatch(createAppointment(createObject)).then(({ payload }) => {
    if (!!payload && hasUuid(payload)) {
      dispatch({
        type: 'UNIMPLEMENTED_ACTION:GET_APPOINTMENT',
        payload: { uuid: payload.uuid, type: 'create' },
      })
      return null
    }
    return null
  })
}
